import angular from 'angular';

module.exports = angular.module('common.services.renovation_service_account_types', [])
.value('renovationServiceAccountTypes', [
  'internet',
  'electricity',
  'water',
  'gas',
  'sewage',
  'trash'
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/renovation_service_account_types.js
 **/